import React from 'react';
import PropTypes from 'prop-types';
import { Formik, Form, Field } from 'formik';
import { Box, Flex, Text } from 'rebass';

import Modal from 'app/modal/v3';
import Button from 'app/buttons';
import CoverField from 'app/form/formik/cover';
import { FT_COLORS } from '../theme';
import { FiX as CloseIcon } from 'react-icons/fi';

// "Edit Photo" modal — wraps the existing CoverField cropper (circular + zoom +
// remove). Save lifts the resulting `avatar` ({ file, zoom, crop-left, crop-top })
// to the parent. Only the original file is kept — no separate canvas image.
const EditPhotoModal = ({ onClose, onSave, currentCover, circular, value }) => (
  <Formik
    initialValues={{ avatar: '' }}
    onSubmit={(values) => onSave(values)}
  >
    {(formik) => {
      const { avatar } = formik.values;
      const hasImage =
        avatar instanceof Blob || avatar?.file instanceof Blob || !!currentCover;
      return (
        <Modal
          title="Edit Photo"
          close={{ onClose }}
          closeOnOutsideClick={false}
          header={{
            right: (
              <Button
                type="button"
                primary
                pill
                onClick={formik.submitForm}
                disabled={!hasImage}
                style={
                  hasImage
                    ? { height: 36, background: FT_COLORS.primary, borderColor: FT_COLORS.primary, color: '#fff' }
                    : { height: 36 }
                }
              >
                Save
              </Button>
            ),
            left: (
              <Text size={24} onClick={onClose} as={CloseIcon} pl="2px" />
            ),
          }}
        >
          <Form>
            <Box p={4}>
              <Flex justifyContent="center">
                <Field
                  name="avatar"
                  component={CoverField}
                  currentCover={currentCover}
                  width={220}
                  circular={circular}
                  hasConfirm
                  hasEditButton
                  showCroppingParams={true}
                  value={value}
                />
              </Flex>
            </Box>
          </Form>
        </Modal>
      );
    }}
  </Formik>
);

EditPhotoModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  currentCover: PropTypes.string,
  circular: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
};

EditPhotoModal.defaultProps = {
  currentCover: '',
  circular: true,
  value: '',
};

export default EditPhotoModal;
